// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type {
    AcceptInvitationUsersData,
    AcceptInvitationUsersErrors,
    AcceptInvitationUsersResponses,
    ActivateProductData,
    ActivateProductErrors,
    ActivateProductResponses,
    CancelEventData,
    CancelEventErrors,
    CancelEventResponses,
    CancelOrdersData,
    CancelOrdersErrors,
    CancelOrdersResponses,
    ComputeAvailabilityData,
    ComputeAvailabilityErrors,
    ComputeAvailabilityResponses,
    ComputePackagePriceBookingsData,
    ComputePackagePriceBookingsErrors,
    ComputePackagePriceBookingsResponses,
    ComputePriceBookingsData,
    ComputePriceBookingsErrors,
    ComputePriceBookingsResponses,
    CreateAssetData,
    CreateAssetErrors,
    CreateAssetResponses,
    CreateBookingData,
    CreateBookingErrors,
    CreateBookingResponses,
    CreateCustomerData,
    CreateCustomerErrors,
    CreateCustomerResponses,
    CreateEventData,
    CreateEventErrors,
    CreateEventResponses,
    CreateManyCapacitiesData,
    CreateManyCapacitiesErrors,
    CreateManyCapacitiesResponses,
    CreateManySchedulesData,
    CreateManySchedulesErrors,
    CreateManySchedulesResponses,
    CreateOrderData,
    CreateOrderErrors,
    CreateOrderResponses,
    CreatePackageBookingsData,
    CreatePackageBookingsErrors,
    CreatePackageBookingsResponses,
    CreateProductData,
    CreateProductErrors,
    CreateProductResponses,
    CreateProductVariantData,
    CreateProductVariantErrors,
    CreateProductVariantResponses,
    CreateReportReportsData,
    CreateReportReportsErrors,
    CreateReportReportsResponses,
    CreateTeamData,
    CreateTeamErrors,
    CreateTeamResponses,
    DeactivateProductData,
    DeactivateProductErrors,
    DeactivateProductResponses,
    DeleteOtaProductVariantData,
    DeleteOtaProductVariantErrors,
    DeleteOtaProductVariantResponses,
    DeleteProductData,
    DeleteProductErrors,
    DeleteProductResponses,
    DeleteTeamData,
    DeleteTeamErrors,
    DeleteTeamResponses,
    DeleteUserAvatarData,
    DeleteUserAvatarErrors,
    DeleteUserAvatarResponses,
    ExportBookingsExportData,
    ExportBookingsExportErrors,
    ExportBookingsExportResponses,
    ExportDetailsOrdersData,
    ExportDetailsOrdersErrors,
    ExportDetailsOrdersResponses,
    FetchTokenWidgetsData,
    FetchTokenWidgetsErrors,
    FetchTokenWidgetsResponses,
    FinishEventsData,
    FinishEventsErrors,
    FinishEventsResponses,
    GenerateProductNameData,
    GenerateProductNameErrors,
    GenerateProductNameResponses,
    GetActivatedOtasData,
    GetActivatedOtasErrors,
    GetActivatedOtasResponses,
    GetAssetData,
    GetAssetErrors,
    GetAssetResponses,
    GetAssetsData,
    GetAssetsErrors,
    GetAssetsResponses,
    GetBookingData,
    GetBookingErrors,
    GetBookingResponses,
    GetBookingsData,
    GetBookingsErrors,
    GetBookingsResponses,
    GetBookingStatsData,
    GetBookingStatsErrors,
    GetBookingStatsResponses,
    GetCapacitiesData,
    GetCapacitiesErrors,
    GetCapacitiesResponses,
    GetCapacityData,
    GetCapacityErrors,
    GetCapacityResponses,
    GetCountryCitiesData,
    GetCountryCitiesErrors,
    GetCountryCitiesResponses,
    GetCustomer1Data,
    GetCustomer1Errors,
    GetCustomer1Responses,
    GetCustomerData,
    GetCustomerErrors,
    GetCustomerResponses,
    GetEventData,
    GetEventErrors,
    GetEventResponses,
    GetEventsData,
    GetEventsErrors,
    GetEventsResponses,
    GetFxData,
    GetFxErrors,
    GetFxResponses,
    GetLocationsData,
    GetLocationsErrors,
    GetLocationsResponses,
    GetManifestData,
    GetManifestResponses,
    GetOrderData,
    GetOrderErrors,
    GetOrderResponses,
    GetOrdersData,
    GetOrdersErrors,
    GetOrdersResponses,
    GetOtaProductVariantsData,
    GetOtaProductVariantsErrors,
    GetOtaProductVariantsResponses,
    GetProductData,
    GetProductErrors,
    GetProductFittingCapacitiesData,
    GetProductFittingCapacitiesErrors,
    GetProductFittingCapacitiesResponses,
    GetProductResponses,
    GetProducts1Data,
    GetProducts1Errors,
    GetProducts1Responses,
    GetProductsData,
    GetProductsErrors,
    GetProductsResponses,
    GetProjectData,
    GetProjectErrors,
    GetProjectResponses,
    GetReportData,
    GetReportErrors,
    GetReportResponses,
    GetReportsData,
    GetReportsErrors,
    GetReportsResponses,
    GetSchedulesData,
    GetSchedulesErrors,
    GetSchedulesResponses,
    GetTeamData,
    GetTeamErrors,
    GetTeamResponses,
    GetTeams1Data,
    GetTeams1Errors,
    GetTeams1Responses,
    GetTeamsData,
    GetTeamsErrors,
    GetTeamsResponses,
    GetUserData,
    GetUserErrors,
    GetUserResponses,
    InviteMemberTeamsData,
    InviteMemberTeamsErrors,
    InviteMemberTeamsResponses,
    RegisterUsersData,
    RegisterUsersErrors,
    RegisterUsersResponses,
    SendOrderCheckoutUrlData,
    SendOrderCheckoutUrlErrors,
    SendOrderCheckoutUrlResponses,
    SetAvatarUsers1Data,
    SetAvatarUsers1Errors,
    SetAvatarUsers1Responses,
    SetCurrentWorkspaceUsersData,
    SetCurrentWorkspaceUsersErrors,
    SetCurrentWorkspaceUsersResponses,
    UpdateAttachmentsCustomersData,
    UpdateAttachmentsCustomersErrors,
    UpdateAttachmentsCustomersResponses,
    UpdateAttachmentsUsersData,
    UpdateAttachmentsUsersErrors,
    UpdateAttachmentsUsersResponses,
    UpdateAvailabilityProductsData,
    UpdateAvailabilityProductsErrors,
    UpdateAvailabilityProductsResponses,
    UpdateBookingNotesBookingsData,
    UpdateBookingNotesBookingsErrors,
    UpdateBookingNotesBookingsResponses,
    UpdateBookingSourceBookingsData,
    UpdateBookingSourceBookingsErrors,
    UpdateBookingSourceBookingsResponses,
    UpdateCapacityEventsData,
    UpdateCapacityEventsErrors,
    UpdateCapacityEventsResponses,
    UpdateCurrencyTeamsData,
    UpdateCurrencyTeamsErrors,
    UpdateCurrencyTeamsResponses,
    UpdateCurrencyUsersData,
    UpdateCurrencyUsersErrors,
    UpdateCurrencyUsersResponses,
    UpdateCustomerData,
    UpdateCustomerErrors,
    UpdateCustomerResponses,
    UpdateCustomersBookingsData,
    UpdateCustomersBookingsErrors,
    UpdateCustomersBookingsResponses,
    UpdateDiscountBookingsData,
    UpdateDiscountBookingsErrors,
    UpdateDiscountBookingsResponses,
    UpdateEventAssetsData,
    UpdateEventAssetsErrors,
    UpdateEventAssetsResponses,
    UpdateEventBookingsData,
    UpdateEventBookingsErrors,
    UpdateEventBookingsResponses,
    UpdateEventDateData,
    UpdateEventDateErrors,
    UpdateEventDateResponses,
    UpdateEventNotesData,
    UpdateEventNotesErrors,
    UpdateEventNotesResponses,
    UpdateEventStaffData,
    UpdateEventStaffErrors,
    UpdateEventStaffResponses,
    UpdateLockEventsData,
    UpdateLockEventsErrors,
    UpdateLockEventsResponses,
    UpdateMembersTeamsData,
    UpdateMembersTeamsErrors,
    UpdateMembersTeamsResponses,
    UpdateOtaStatusData,
    UpdateOtaStatusErrors,
    UpdateOtaStatusResponses,
    UpdatePackageDiscountData,
    UpdatePackageDiscountErrors,
    UpdatePackageDiscountResponses,
    UpdatePaymentGatewayTeamsData,
    UpdatePaymentGatewayTeamsErrors,
    UpdatePaymentGatewayTeamsResponses,
    UpdatePaymentGatewayUsersData,
    UpdatePaymentGatewayUsersErrors,
    UpdatePaymentGatewayUsersResponses,
    UpdateProductAttachmentsData,
    UpdateProductAttachmentsErrors,
    UpdateProductAttachmentsResponses,
    UpdateProductCapacitiesData,
    UpdateProductCapacitiesErrors,
    UpdateProductCapacitiesResponses,
    UpdateProductConfigurationData,
    UpdateProductConfigurationErrors,
    UpdateProductConfigurationResponses,
    UpdateProductData,
    UpdateProductErrors,
    UpdateProductOptionsBookingsData,
    UpdateProductOptionsBookingsErrors,
    UpdateProductOptionsBookingsResponses,
    UpdateProductOptionsData,
    UpdateProductOptionsErrors,
    UpdateProductOptionsResponses,
    UpdateProductPoliciesData,
    UpdateProductPoliciesErrors,
    UpdateProductPoliciesResponses,
    UpdateProductPricingData,
    UpdateProductPricingErrors,
    UpdateProductPricingResponses,
    UpdateProductResponses,
    UpdateProductRoutesData,
    UpdateProductRoutesErrors,
    UpdateProductRoutesResponses,
    UpdateProductScheduleData,
    UpdateProductScheduleErrors,
    UpdateProductScheduleResponses,
    UpdateStatusBookingsData,
    UpdateStatusBookingsErrors,
    UpdateStatusBookingsResponses,
    UpdateTeamPoliciesData,
    UpdateTeamPoliciesErrors,
    UpdateTeamPoliciesResponses,
    UpdateTeamSettingsData,
    UpdateTeamSettingsErrors,
    UpdateTeamSettingsResponses,
    UpdateTransactionsBookingsData,
    UpdateTransactionsBookingsErrors,
    UpdateTransactionsBookingsResponses,
    UpdateUserData,
    UpdateUserErrors,
    UpdateUserPoliciesData,
    UpdateUserPoliciesErrors,
    UpdateUserPoliciesResponses,
    UpdateUserResponses,
} from './types.gen';

export type Options<
    TData extends TDataShape = TDataShape,
    ThrowOnError extends boolean = boolean
> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export class ProjectService {
    public static getProject<ThrowOnError extends boolean = false>(
        options: Options<GetProjectData, ThrowOnError>
    ) {
        return (options.client ?? client).get<
            GetProjectResponses,
            GetProjectErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/project/subscriptions/{subscription_key}',
            ...options,
        });
    }

    public static getManifest<ThrowOnError extends boolean = false>(
        options?: Options<GetManifestData, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            GetManifestResponses,
            unknown,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/project/manifest',
            ...options,
        });
    }

    public static getCountryCities<ThrowOnError extends boolean = false>(
        options: Options<GetCountryCitiesData, ThrowOnError>
    ) {
        return (options.client ?? client).get<
            GetCountryCitiesResponses,
            GetCountryCitiesErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/project/manifest/{country_name}/cities',
            ...options,
        });
    }
}

export class UsersService {
    public static registerUsers<ThrowOnError extends boolean = false>(
        options: Options<RegisterUsersData, ThrowOnError>
    ) {
        return (options.client ?? client).post<
            RegisterUsersResponses,
            RegisterUsersErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/users/register',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static getUser<ThrowOnError extends boolean = false>(
        options?: Options<GetUserData, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            GetUserResponses,
            GetUserErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/users/me',
            ...options,
        });
    }

    public static updateUser<ThrowOnError extends boolean = false>(
        options: Options<UpdateUserData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateUserResponses,
            UpdateUserErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/users/me',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static deleteUserAvatar<ThrowOnError extends boolean = false>(
        options?: Options<DeleteUserAvatarData, ThrowOnError>
    ) {
        return (options?.client ?? client).delete<
            DeleteUserAvatarResponses,
            DeleteUserAvatarErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/users/me/avatar',
            ...options,
        });
    }

    public static setAvatarUsers1<ThrowOnError extends boolean = false>(
        options: Options<SetAvatarUsers1Data, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            SetAvatarUsers1Responses,
            SetAvatarUsers1Errors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/users/me/avatar',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateAttachmentsUsers<ThrowOnError extends boolean = false>(
        options: Options<UpdateAttachmentsUsersData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateAttachmentsUsersResponses,
            UpdateAttachmentsUsersErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/users/me/attachments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateCurrencyUsers<ThrowOnError extends boolean = false>(
        options: Options<UpdateCurrencyUsersData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateCurrencyUsersResponses,
            UpdateCurrencyUsersErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/users/me/currency',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static setCurrentWorkspaceUsers<
        ThrowOnError extends boolean = false
    >(options: Options<SetCurrentWorkspaceUsersData, ThrowOnError>) {
        return (options.client ?? client).patch<
            SetCurrentWorkspaceUsersResponses,
            SetCurrentWorkspaceUsersErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/users/me/workspace/{workspace_id}',
            ...options,
        });
    }

    public static acceptInvitationUsers<ThrowOnError extends boolean = false>(
        options: Options<AcceptInvitationUsersData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            AcceptInvitationUsersResponses,
            AcceptInvitationUsersErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/users/me/accept_invitation/{key}',
            ...options,
        });
    }

    public static updateUserPolicies<ThrowOnError extends boolean = false>(
        options: Options<UpdateUserPoliciesData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateUserPoliciesResponses,
            UpdateUserPoliciesErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/users/me/policies',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updatePaymentGatewayUsers<
        ThrowOnError extends boolean = false
    >(options: Options<UpdatePaymentGatewayUsersData, ThrowOnError>) {
        return (options.client ?? client).patch<
            UpdatePaymentGatewayUsersResponses,
            UpdatePaymentGatewayUsersErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/users/me/payment-gateways',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }
}

export class TeamsService {
    public static getTeams<ThrowOnError extends boolean = false>(
        options?: Options<GetTeamsData, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            GetTeamsResponses,
            GetTeamsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/teams',
            ...options,
        });
    }

    public static createTeam<ThrowOnError extends boolean = false>(
        options: Options<CreateTeamData, ThrowOnError>
    ) {
        return (options.client ?? client).post<
            CreateTeamResponses,
            CreateTeamErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/teams',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static deleteTeam<ThrowOnError extends boolean = false>(
        options: Options<DeleteTeamData, ThrowOnError>
    ) {
        return (options.client ?? client).delete<
            DeleteTeamResponses,
            DeleteTeamErrors,
            ThrowOnError
        >({
            url: '/api/v1/teams/{team_id}',
            ...options,
        });
    }

    public static getTeam<ThrowOnError extends boolean = false>(
        options: Options<GetTeamData, ThrowOnError>
    ) {
        return (options.client ?? client).get<
            GetTeamResponses,
            GetTeamErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/teams/{team_id}',
            ...options,
        });
    }

    public static updateMembersTeams<ThrowOnError extends boolean = false>(
        options: Options<UpdateMembersTeamsData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateMembersTeamsResponses,
            UpdateMembersTeamsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/teams/{team_id}/members',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateTeamSettings<ThrowOnError extends boolean = false>(
        options: Options<UpdateTeamSettingsData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateTeamSettingsResponses,
            UpdateTeamSettingsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/teams/{team_id}/account/settings',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static getTeams1<ThrowOnError extends boolean = false>(
        options: Options<GetTeams1Data, ThrowOnError>
    ) {
        return (options.client ?? client).post<
            GetTeams1Responses,
            GetTeams1Errors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/teams/community_members',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static inviteMemberTeams<ThrowOnError extends boolean = false>(
        options: Options<InviteMemberTeamsData, ThrowOnError>
    ) {
        return (options.client ?? client).post<
            InviteMemberTeamsResponses,
            InviteMemberTeamsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/teams/{team_id}/members/{member_id}/invite',
            ...options,
        });
    }

    public static updateCurrencyTeams<ThrowOnError extends boolean = false>(
        options: Options<UpdateCurrencyTeamsData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateCurrencyTeamsResponses,
            UpdateCurrencyTeamsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/teams/{team_id}/currency',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateTeamPolicies<ThrowOnError extends boolean = false>(
        options: Options<UpdateTeamPoliciesData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateTeamPoliciesResponses,
            UpdateTeamPoliciesErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/teams/{team_id}/policies',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updatePaymentGatewayTeams<
        ThrowOnError extends boolean = false
    >(options: Options<UpdatePaymentGatewayTeamsData, ThrowOnError>) {
        return (options.client ?? client).patch<
            UpdatePaymentGatewayTeamsResponses,
            UpdatePaymentGatewayTeamsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/teams/{team_id}/payment-gateways',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }
}

export class ProductsService {
    public static computeAvailability<ThrowOnError extends boolean = false>(
        options: Options<ComputeAvailabilityData, ThrowOnError>
    ) {
        return (options.client ?? client).post<
            ComputeAvailabilityResponses,
            ComputeAvailabilityErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/availability',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static getProducts<ThrowOnError extends boolean = false>(
        options?: Options<GetProductsData, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            GetProductsResponses,
            GetProductsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products',
            ...options,
        });
    }

    public static createProduct<ThrowOnError extends boolean = false>(
        options: Options<CreateProductData, ThrowOnError>
    ) {
        return (options.client ?? client).post<
            CreateProductResponses,
            CreateProductErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static getProducts1<ThrowOnError extends boolean = false>(
        options?: Options<GetProducts1Data, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            GetProducts1Responses,
            GetProducts1Errors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products/references',
            ...options,
        });
    }

    public static getProductFittingCapacities<
        ThrowOnError extends boolean = false
    >(options: Options<GetProductFittingCapacitiesData, ThrowOnError>) {
        return (options.client ?? client).post<
            GetProductFittingCapacitiesResponses,
            GetProductFittingCapacitiesErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products/{product_id}/fitting_capacities',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateProduct<ThrowOnError extends boolean = false>(
        options: Options<UpdateProductData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateProductResponses,
            UpdateProductErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products/{product_id}/details',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updatePackageDiscount<ThrowOnError extends boolean = false>(
        options: Options<UpdatePackageDiscountData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdatePackageDiscountResponses,
            UpdatePackageDiscountErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products/{product_id}/discount',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateProductRoutes<ThrowOnError extends boolean = false>(
        options: Options<UpdateProductRoutesData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateProductRoutesResponses,
            UpdateProductRoutesErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products/{product_id}/route',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateProductCapacities<ThrowOnError extends boolean = false>(
        options: Options<UpdateProductCapacitiesData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateProductCapacitiesResponses,
            UpdateProductCapacitiesErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products/{product_id}/capacity',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateProductSchedule<ThrowOnError extends boolean = false>(
        options: Options<UpdateProductScheduleData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateProductScheduleResponses,
            UpdateProductScheduleErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products/{product_id}/schedule',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateProductPricing<ThrowOnError extends boolean = false>(
        options: Options<UpdateProductPricingData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateProductPricingResponses,
            UpdateProductPricingErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products/{product_id}/pricing',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateProductOptions<ThrowOnError extends boolean = false>(
        options: Options<UpdateProductOptionsData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateProductOptionsResponses,
            UpdateProductOptionsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products/{product_id}/options',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateProductConfiguration<
        ThrowOnError extends boolean = false
    >(options: Options<UpdateProductConfigurationData, ThrowOnError>) {
        return (options.client ?? client).patch<
            UpdateProductConfigurationResponses,
            UpdateProductConfigurationErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products/{product_id}/configuration',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static activateProduct<ThrowOnError extends boolean = false>(
        options: Options<ActivateProductData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            ActivateProductResponses,
            ActivateProductErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products/{product_id}/activate',
            ...options,
        });
    }

    public static deactivateProduct<ThrowOnError extends boolean = false>(
        options: Options<DeactivateProductData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            DeactivateProductResponses,
            DeactivateProductErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products/{product_id}/deactivate',
            ...options,
        });
    }

    public static updateProductAttachments<
        ThrowOnError extends boolean = false
    >(options: Options<UpdateProductAttachmentsData, ThrowOnError>) {
        return (options.client ?? client).patch<
            UpdateProductAttachmentsResponses,
            UpdateProductAttachmentsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products/{product_id}/attachments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateAvailabilityProducts<
        ThrowOnError extends boolean = false
    >(options: Options<UpdateAvailabilityProductsData, ThrowOnError>) {
        return (options.client ?? client).patch<
            UpdateAvailabilityProductsResponses,
            UpdateAvailabilityProductsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products/{product_id}/availability',
            ...options,
        });
    }

    public static deleteProduct<ThrowOnError extends boolean = false>(
        options: Options<DeleteProductData, ThrowOnError>
    ) {
        return (options.client ?? client).delete<
            DeleteProductResponses,
            DeleteProductErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products/{product_id}',
            ...options,
        });
    }

    public static getProduct<ThrowOnError extends boolean = false>(
        options: Options<GetProductData, ThrowOnError>
    ) {
        return (options.client ?? client).get<
            GetProductResponses,
            GetProductErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products/{product_id}',
            ...options,
        });
    }

    public static generateProductName<ThrowOnError extends boolean = false>(
        options?: Options<GenerateProductNameData, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            GenerateProductNameResponses,
            GenerateProductNameErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products/generate_name',
            ...options,
        });
    }

    public static updateProductPolicies<ThrowOnError extends boolean = false>(
        options: Options<UpdateProductPoliciesData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateProductPoliciesResponses,
            UpdateProductPoliciesErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/products/{product_id}/policies',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }
}

export class ReportsService {
    public static getReports<ThrowOnError extends boolean = false>(
        options?: Options<GetReportsData, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            GetReportsResponses,
            GetReportsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/reports',
            ...options,
        });
    }

    public static createReportReports<ThrowOnError extends boolean = false>(
        options: Options<CreateReportReportsData, ThrowOnError>
    ) {
        return (options.client ?? client).post<
            CreateReportReportsResponses,
            CreateReportReportsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/reports',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static getReport<ThrowOnError extends boolean = false>(
        options: Options<GetReportData, ThrowOnError>
    ) {
        return (options.client ?? client).get<
            GetReportResponses,
            GetReportErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/reports/{report_id}',
            ...options,
        });
    }
}

export class ProductVariantsService {
    public static getOtaProductVariants<ThrowOnError extends boolean = false>(
        options?: Options<GetOtaProductVariantsData, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            GetOtaProductVariantsResponses,
            GetOtaProductVariantsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/product_variants',
            ...options,
        });
    }

    public static createProductVariant<ThrowOnError extends boolean = false>(
        options: Options<CreateProductVariantData, ThrowOnError>
    ) {
        return (options.client ?? client).post<
            CreateProductVariantResponses,
            CreateProductVariantErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/product_variants',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static deleteOtaProductVariant<ThrowOnError extends boolean = false>(
        options: Options<DeleteOtaProductVariantData, ThrowOnError>
    ) {
        return (options.client ?? client).delete<
            DeleteOtaProductVariantResponses,
            DeleteOtaProductVariantErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/product_variants/{product_variant_id}',
            ...options,
        });
    }
}

export class EventsService {
    public static getEvents<ThrowOnError extends boolean = false>(
        options?: Options<GetEventsData, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            GetEventsResponses,
            GetEventsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/events',
            ...options,
        });
    }

    public static createEvent<ThrowOnError extends boolean = false>(
        options: Options<CreateEventData, ThrowOnError>
    ) {
        return (options.client ?? client).post<
            CreateEventResponses,
            CreateEventErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/events',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static getEvent<ThrowOnError extends boolean = false>(
        options: Options<GetEventData, ThrowOnError>
    ) {
        return (options.client ?? client).get<
            GetEventResponses,
            GetEventErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/events/{event_id}',
            ...options,
        });
    }

    public static cancelEvent<ThrowOnError extends boolean = false>(
        options: Options<CancelEventData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            CancelEventResponses,
            CancelEventErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/events/{event_id}/cancel',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateEventDate<ThrowOnError extends boolean = false>(
        options: Options<UpdateEventDateData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateEventDateResponses,
            UpdateEventDateErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/events/{event_id}/date',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateEventStaff<ThrowOnError extends boolean = false>(
        options: Options<UpdateEventStaffData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateEventStaffResponses,
            UpdateEventStaffErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/events/{event_id}/staff',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateEventAssets<ThrowOnError extends boolean = false>(
        options: Options<UpdateEventAssetsData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateEventAssetsResponses,
            UpdateEventAssetsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/events/{event_id}/assets',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateCapacityEvents<ThrowOnError extends boolean = false>(
        options: Options<UpdateCapacityEventsData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateCapacityEventsResponses,
            UpdateCapacityEventsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/events/{event_id}/capacity/{capacity_id}',
            ...options,
        });
    }

    public static updateEventNotes<ThrowOnError extends boolean = false>(
        options: Options<UpdateEventNotesData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateEventNotesResponses,
            UpdateEventNotesErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/events/{event_id}/notes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateLockEvents<ThrowOnError extends boolean = false>(
        options: Options<UpdateLockEventsData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateLockEventsResponses,
            UpdateLockEventsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/events/{event_id}/lock',
            ...options,
        });
    }

    public static finishEvents<ThrowOnError extends boolean = false>(
        options: Options<FinishEventsData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            FinishEventsResponses,
            FinishEventsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/events/{event_id}/finish',
            ...options,
        });
    }
}

export class CapacitiesService {
    public static getCapacities<ThrowOnError extends boolean = false>(
        options?: Options<GetCapacitiesData, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            GetCapacitiesResponses,
            GetCapacitiesErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/capacities',
            ...options,
        });
    }

    public static createManyCapacities<ThrowOnError extends boolean = false>(
        options: Options<CreateManyCapacitiesData, ThrowOnError>
    ) {
        return (options.client ?? client).post<
            CreateManyCapacitiesResponses,
            CreateManyCapacitiesErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/capacities',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static getCapacity<ThrowOnError extends boolean = false>(
        options: Options<GetCapacityData, ThrowOnError>
    ) {
        return (options.client ?? client).get<
            GetCapacityResponses,
            GetCapacityErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/capacities/{capacity_id}',
            ...options,
        });
    }
}

export class SchedulesService {
    public static getSchedules<ThrowOnError extends boolean = false>(
        options?: Options<GetSchedulesData, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            GetSchedulesResponses,
            GetSchedulesErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/schedules',
            ...options,
        });
    }

    public static createManySchedules<ThrowOnError extends boolean = false>(
        options: Options<CreateManySchedulesData, ThrowOnError>
    ) {
        return (options.client ?? client).post<
            CreateManySchedulesResponses,
            CreateManySchedulesErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/schedules',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }
}

export class StatsService {
    public static getBookingStats<ThrowOnError extends boolean = false>(
        options: Options<GetBookingStatsData, ThrowOnError>
    ) {
        return (options.client ?? client).get<
            GetBookingStatsResponses,
            GetBookingStatsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/stats/booking',
            ...options,
        });
    }
}

export class AssetsService {
    public static getAssets<ThrowOnError extends boolean = false>(
        options?: Options<GetAssetsData, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            GetAssetsResponses,
            GetAssetsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/assets',
            ...options,
        });
    }

    public static createAsset<ThrowOnError extends boolean = false>(
        options: Options<CreateAssetData, ThrowOnError>
    ) {
        return (options.client ?? client).post<
            CreateAssetResponses,
            CreateAssetErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/assets',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static getAsset<ThrowOnError extends boolean = false>(
        options: Options<GetAssetData, ThrowOnError>
    ) {
        return (options.client ?? client).get<
            GetAssetResponses,
            GetAssetErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/assets/{asset_id}',
            ...options,
        });
    }
}

export class BookingsService {
    public static getBookings<ThrowOnError extends boolean = false>(
        options?: Options<GetBookingsData, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            GetBookingsResponses,
            GetBookingsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/bookings',
            ...options,
        });
    }

    public static createBooking<ThrowOnError extends boolean = false>(
        options: Options<CreateBookingData, ThrowOnError>
    ) {
        return (options.client ?? client).post<
            CreateBookingResponses,
            CreateBookingErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/bookings',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static createPackageBookings<ThrowOnError extends boolean = false>(
        options: Options<CreatePackageBookingsData, ThrowOnError>
    ) {
        return (options.client ?? client).post<
            CreatePackageBookingsResponses,
            CreatePackageBookingsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/bookings/package',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static getBooking<ThrowOnError extends boolean = false>(
        options: Options<GetBookingData, ThrowOnError>
    ) {
        return (options.client ?? client).get<
            GetBookingResponses,
            GetBookingErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/bookings/{booking_id}',
            ...options,
        });
    }

    public static updateEventBookings<ThrowOnError extends boolean = false>(
        options: Options<UpdateEventBookingsData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateEventBookingsResponses,
            UpdateEventBookingsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/bookings/{booking_id}/event',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateCustomersBookings<ThrowOnError extends boolean = false>(
        options: Options<UpdateCustomersBookingsData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateCustomersBookingsResponses,
            UpdateCustomersBookingsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/bookings/{booking_id}/customers',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateProductOptionsBookings<
        ThrowOnError extends boolean = false
    >(options: Options<UpdateProductOptionsBookingsData, ThrowOnError>) {
        return (options.client ?? client).patch<
            UpdateProductOptionsBookingsResponses,
            UpdateProductOptionsBookingsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/bookings/{booking_id}/product_options',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateStatusBookings<ThrowOnError extends boolean = false>(
        options: Options<UpdateStatusBookingsData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateStatusBookingsResponses,
            UpdateStatusBookingsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/bookings/{booking_id}/status',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateBookingSourceBookings<
        ThrowOnError extends boolean = false
    >(options: Options<UpdateBookingSourceBookingsData, ThrowOnError>) {
        return (options.client ?? client).patch<
            UpdateBookingSourceBookingsResponses,
            UpdateBookingSourceBookingsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/bookings/{booking_id}/source',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateTransactionsBookings<
        ThrowOnError extends boolean = false
    >(options: Options<UpdateTransactionsBookingsData, ThrowOnError>) {
        return (options.client ?? client).patch<
            UpdateTransactionsBookingsResponses,
            UpdateTransactionsBookingsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/bookings/{booking_id}/transactions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateBookingNotesBookings<
        ThrowOnError extends boolean = false
    >(options: Options<UpdateBookingNotesBookingsData, ThrowOnError>) {
        return (options.client ?? client).patch<
            UpdateBookingNotesBookingsResponses,
            UpdateBookingNotesBookingsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/bookings/{booking_id}/notes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateDiscountBookings<ThrowOnError extends boolean = false>(
        options: Options<UpdateDiscountBookingsData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateDiscountBookingsResponses,
            UpdateDiscountBookingsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/bookings/{booking_id}/discount',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static computePriceBookings<ThrowOnError extends boolean = false>(
        options: Options<ComputePriceBookingsData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            ComputePriceBookingsResponses,
            ComputePriceBookingsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/bookings/compute_price',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static computePackagePriceBookings<
        ThrowOnError extends boolean = false
    >(options: Options<ComputePackagePriceBookingsData, ThrowOnError>) {
        return (options.client ?? client).patch<
            ComputePackagePriceBookingsResponses,
            ComputePackagePriceBookingsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/bookings/package/compute_price',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }
}

export class ExportReportsService {
    public static exportBookingsExport<ThrowOnError extends boolean = false>(
        options: Options<ExportBookingsExportData, ThrowOnError>
    ) {
        return (options.client ?? client).get<
            ExportBookingsExportResponses,
            ExportBookingsExportErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/export/bookings',
            ...options,
        });
    }
}

export class CustomersService {
    public static getCustomer<ThrowOnError extends boolean = false>(
        options?: Options<GetCustomerData, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            GetCustomerResponses,
            GetCustomerErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/customers',
            ...options,
        });
    }

    public static createCustomer<ThrowOnError extends boolean = false>(
        options: Options<CreateCustomerData, ThrowOnError>
    ) {
        return (options.client ?? client).post<
            CreateCustomerResponses,
            CreateCustomerErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/customers',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static getCustomer1<ThrowOnError extends boolean = false>(
        options: Options<GetCustomer1Data, ThrowOnError>
    ) {
        return (options.client ?? client).get<
            GetCustomer1Responses,
            GetCustomer1Errors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/customers/{customer_id}',
            ...options,
        });
    }

    public static updateCustomer<ThrowOnError extends boolean = false>(
        options: Options<UpdateCustomerData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            UpdateCustomerResponses,
            UpdateCustomerErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/customers/{customer_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static updateAttachmentsCustomers<
        ThrowOnError extends boolean = false
    >(options: Options<UpdateAttachmentsCustomersData, ThrowOnError>) {
        return (options.client ?? client).patch<
            UpdateAttachmentsCustomersResponses,
            UpdateAttachmentsCustomersErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/customers/{customer_id}/attachments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }
}

export class OrdersService {
    public static getOrders<ThrowOnError extends boolean = false>(
        options?: Options<GetOrdersData, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            GetOrdersResponses,
            GetOrdersErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/orders',
            ...options,
        });
    }

    public static createOrder<ThrowOnError extends boolean = false>(
        options: Options<CreateOrderData, ThrowOnError>
    ) {
        return (options.client ?? client).post<
            CreateOrderResponses,
            CreateOrderErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/orders',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static getOrder<ThrowOnError extends boolean = false>(
        options: Options<GetOrderData, ThrowOnError>
    ) {
        return (options.client ?? client).get<
            GetOrderResponses,
            GetOrderErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/orders/{order_id}',
            ...options,
        });
    }

    public static cancelOrders<ThrowOnError extends boolean = false>(
        options: Options<CancelOrdersData, ThrowOnError>
    ) {
        return (options.client ?? client).patch<
            CancelOrdersResponses,
            CancelOrdersErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/orders/{order_id}/cancel',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });
    }

    public static exportDetailsOrders<ThrowOnError extends boolean = false>(
        options: Options<ExportDetailsOrdersData, ThrowOnError>
    ) {
        return (options.client ?? client).get<
            ExportDetailsOrdersResponses,
            ExportDetailsOrdersErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/orders/{order_id}/export',
            ...options,
        });
    }

    public static sendOrderCheckoutUrl<ThrowOnError extends boolean = false>(
        options: Options<SendOrderCheckoutUrlData, ThrowOnError>
    ) {
        return (options.client ?? client).post<
            SendOrderCheckoutUrlResponses,
            SendOrderCheckoutUrlErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/orders/{order_id}/checkout_url',
            ...options,
        });
    }
}

export class OtaIntegrationsService {
    public static updateOtaStatus<ThrowOnError extends boolean = false>(
        options: Options<UpdateOtaStatusData, ThrowOnError>
    ) {
        return (options.client ?? client).post<
            UpdateOtaStatusResponses,
            UpdateOtaStatusErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/otas/{ota_name}',
            ...options,
        });
    }

    public static getActivatedOtas<ThrowOnError extends boolean = false>(
        options?: Options<GetActivatedOtasData, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            GetActivatedOtasResponses,
            GetActivatedOtasErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/otas',
            ...options,
        });
    }
}

export class WidgetsService {
    public static fetchTokenWidgets<ThrowOnError extends boolean = false>(
        options?: Options<FetchTokenWidgetsData, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            FetchTokenWidgetsResponses,
            FetchTokenWidgetsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/widgets/token',
            ...options,
        });
    }
}

export class CurrencyService {
    public static getFx<ThrowOnError extends boolean = false>(
        options?: Options<GetFxData, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            GetFxResponses,
            GetFxErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/fx/latest',
            ...options,
        });
    }
}

export class LocationsService {
    public static getLocations<ThrowOnError extends boolean = false>(
        options?: Options<GetLocationsData, ThrowOnError>
    ) {
        return (options?.client ?? client).get<
            GetLocationsResponses,
            GetLocationsErrors,
            ThrowOnError
        >({
            responseType: 'json',
            url: '/api/v1/locations',
            ...options,
        });
    }
}
